
import request from '@/utils/server'
 


  // 列表
  export function getRequiredMaterials(query) {
    return request({
      url: '/production/getRequiredMaterials',
      method: 'get',
     params: query
    })
  }

    export function calculateList(data) {
    return request({
      url: '/production/calculateList',
      method: 'POST',
    data:data
    })
  }